import { CalendarViewDesktop, CalendarViewMobile } from "@/features/calendar";
import { ResponsiveBlockSwitcher } from "@/shared/Components";

export const CalendarPageV2 = () => {
  return (
    <ResponsiveBlockSwitcher desktop={<CalendarViewDesktop />} mobile={<CalendarViewMobile />} />
  );
};
